import React from "react";
import PropTypes from "prop-types";

import { Border } from "./Border";
import { Content } from "./Content";
import { Wrapper } from "./Wrapper";
import { DesignChapter } from "@learningblocks/storybook-components";

import style from "./style.module.scss";

export function Empty(props) {
  const [showOptions, setShowOptions] = React.useState(false);

  const renderMobileLayer = () => {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={() => setShowOptions(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            setShowOptions(true);
          }
        }}
        className="mob_OutcomeEmpty"
      ></div>
    );
  };

  const closeModal = () => setShowOptions(false);

  const wrapperClass = `${style.hex} ${props.className}`;

  const textClass = `${style.hex_text} ${props.className}_text`;

  const borderClass = `${style.hex_border} ${props.className}_border`;

  return (
    <>
      {showOptions && (
        <DesignChapter.ExperimentOutcomesModal
          list={props.options}
          onAddStep={props.onAddStep}
          close={closeModal}
          isOpen={true}
        />
      )}
      <Wrapper className={wrapperClass}>
        <Border className={borderClass} />
        <Content text={props.text} className={textClass} />
      </Wrapper>
      {renderMobileLayer()}
    </>
  );
}

Empty.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * text to display on component
   */
  text: PropTypes.string,
  /**
   * function to invoke on adding new step
   */
  onAddStep: PropTypes.func,
};

Empty.defaultProps = {
  className: "",
};
